<template>
  <div class="video-player">
    <video ref="video"
           class="video"
           :controls="controls"
           :poster="poster"
           @playing="onPlaying"
           @pause="onPause"
           @ended="onEnded"
           @play="onPlay"
           v-on="{ click: !controls ? stop : () => {} }"
           :src="videoUrl"/>
    <img class="play-button" v-if="!controls && !isPlaying" @click="playVideo" :src="require('../assets/play-video.svg')"/>
  </div>
</template>

<script>
export default {
  name: 'VideoPlayer',
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
    controls: Boolean,
    poster: String,
  },
  data() {
    return {
      isPlaying: false,
    };
  },
  methods: {
    async playVideo() {
      if (!this.isPlaying) {
        try {
          await this.$refs.video.play();
        } catch (error) {
          // AbortError can be thrown if the movie is interrupted by the user
          // after the play() function was called but before the movie actually
          // started playing. There's no way we can prevent that and there's nothing
          // much we can do once we know it happened.
          if (error.name !== 'AbortError') {
            throw error;
          }
        }
      }
    },
    stop() {
      if (this.isPlaying) {
        this.$refs.video.pause();
        this.isPlaying = false;
      }
    },
    onEnded() {
      this.isPlaying = false;
      this.$refs.video.currentTime = 0;
    },
    onPlaying() {
      this.isPlaying = true;
    },
    onPause() {
      this.isPlaying = false;
    },
    onPlay() {
      this.$emit('video-played');
    },
  },
};
</script>

<style scoped lang="scss">
.video-player {
  width: 100%;
  position: relative;

  .video {
    width: 100%;
  }

  .play-button {
    position: absolute;
    width: 80px;
    height: 80px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

</style>
